import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
  selector: 'bmcore-textarea',
  templateUrl: './bmcore-textarea.component.html',
  styleUrls: ['./bmcore-textarea.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreTextareaComponent {
  @Input() placeholder = ''
}
